export default "__VITE_ASSET__Bo7p1Gd2__"